module.exports = __webpack_public_path__ + "assets/images/Agenda/genapi.c50807cc7350105e78496fe3afb8bfee.png";